import FingerprintJS from "@fingerprintjs/fingerprintjs";
const fpPromise = FingerprintJS.load();
let fingerprintCache = null;
export async function getFingerprint() {
    if (fingerprintCache) {
        return fingerprintCache;
    }
    const stored = localStorage.getItem("fingerprint");
    if (stored) {
        fingerprintCache = stored;
        return fingerprintCache;
    }
    try {
        const promise = await fpPromise;
        const visitorData = await promise.get();
        localStorage.setItem("fingerprint", visitorData.visitorId);
        return visitorData.visitorId;
    }
    catch (error) {
        console.error("FingerprintJS error, using fallback:", error);
        const fallback = generateFallbackFingerprint();
        fingerprintCache = fallback;
        localStorage.setItem("fingerprint", fallback);
        return fallback;
    }
}
function generateFallbackFingerprint() {
    const data = [
        navigator.userAgent,
        navigator.language,
        screen.width,
        screen.height,
        new Date().getTimezoneOffset()
    ].join("|");
    let hash = 0;
    for (let i = 0; i < data.length; i++) {
        hash = ((hash << 5) - hash) + data.charCodeAt(i);
        hash |= 0;
    }
    return `fp_fallback_${Math.abs(hash).toString(36)}_${Date.now().toString(36)}`;
}
